import React from "react"
import { Container, Col, Row } from "react-bootstrap"
import { SidemenuComponent } from "../../Components/Admin/Sidemenu"
import { SetNotification } from "../../Components/Admin/AdminNotification"
const AdminaddNotificationpage = () => {
  return (
    <Container fluid>
      <Row>
        <Col
          lg="10"
          sm="12"
          className="px-0"
          style={{
            marginLeft: window.innerWidth >= 992 ? "17%" : "0",
          }}
        >
          <SetNotification />
        </Col>
      </Row>
    </Container>
  )
}
export default AdminaddNotificationpage
